import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
const GOLD = '#C9A96E';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center bg-nude-light overflow-hidden px-6 py-24" data-id="element-92">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-93">
        <div className="absolute top-[-10%] left-[-5%] w-96 h-96 bg-rosado-soft rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-94"></div>
        <div className="absolute bottom-[-10%] right-[-5%] w-96 h-96 bg-nude rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-95"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-97">
          <h2 className="text-sm md:text-base font-sans tracking-[0.3em] uppercase mb-5" style={{
          color: GOLD
        }} data-id="element-98">
            ALEXA BEAUTY{' '}
            <span className="font-light tracking-[0.2em]" data-id="element-99">
              Brows And Lashes
            </span>
          </h2>

          <h1 className="text-[2.5rem] md:text-6xl lg:text-7xl font-serif font-medium text-luxury-black leading-tight mb-4" data-id="element-100">
            TODO LO QUE NECESITAS PARA PESTAÑAS, EN UN SOLO KIT.
          </h1>

          {/* Decorative gold line */}
          <motion.div initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="mx-auto mb-8 h-[1px] w-24 origin-center" style={{
          backgroundColor: GOLD
        }} data-id="element-101" />

          <p className="text-lg md:text-xl text-gray-600 font-sans font-light max-w-2xl mx-auto mb-14 leading-relaxed" data-id="element-102">
            <span style={{
            color: GOLD
          }} className="font-normal" data-id="element-103">
              Organiza
            </span>{' '}
            tu trabajo,{' '}
            <span style={{
            color: GOLD
          }} className="font-normal" data-id="element-104">
              ahorra tiempo
            </span>{' '}
            y proyecta una{' '}
            <span style={{
            color: GOLD
          }} className="font-normal" data-id="element-105">
              imagen profesional
            </span>{' '}
            con un kit diseñado para tener todo bajo control, sin
            complicaciones.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-gray-500 font-sans mb-12" data-id="element-106">
            <motion.span whileHover={{
            scale: 1.05
          }} className="flex items-center gap-2 cursor-default transition-colors duration-300" data-id="element-107">
              <SparklesIcon className="w-4 h-4 transition-all duration-300" style={{
              color: GOLD
            }} data-id="element-108" />
              Elegancia en cada detalle
            </motion.span>
            <motion.span whileHover={{
            scale: 1.05
          }} className="flex items-center gap-2 cursor-default transition-colors duration-300" data-id="element-109">
              <SparklesIcon className="w-4 h-4 transition-all duration-300" style={{
              color: GOLD
            }} data-id="element-110" />
              Organización sin esfuerzo
            </motion.span>
            <motion.span whileHover={{
            scale: 1.05
          }} className="flex items-center gap-2 cursor-default transition-colors duration-300" data-id="element-111">
              <SparklesIcon className="w-4 h-4 transition-all duration-300" style={{
              color: GOLD
            }} data-id="element-112" />
              Diseñado para resultados profesionales
            </motion.span>
          </div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 0.8
        }} className="text-base md:text-lg text-luxury-dark/80 font-serif italic max-w-xl mx-auto leading-relaxed" data-id="element-113">
            Trabaja con más seguridad, más orden y más{' '}
            <span style={{
            color: GOLD
          }} className="not-italic font-medium" data-id="element-114">
              confianza
            </span>
            … todo empieza con tener lo correcto contigo.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}